import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import ShopCardRoot from '../_partials/ShopCardRoot';
import DeviationThumbIndicators, { AllowedIndicators } from '../../DeviationViews/Thumb/legos/DeviationThumbIndicators';
import s from './HiddenShopCard.scss';
const HiddenShopCard = ({ deviation, width, height, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(ShopCardRoot, {
        height: height,
        width: width,
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['gradient-underlay']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['indicators-slot']
    }, /*#__PURE__*/ React.createElement(DeviationThumbIndicators, {
        deviation: deviation,
        allowedIndicators: AllowedIndicators.Flag
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['heading']
    }, t('shop.thumb.hidden.privatePurchase.heading')), /*#__PURE__*/ React.createElement("p", {
        className: s['subtext']
    }, t('shop.thumb.hidden.privatePurchase.subtext'))));
};
HiddenShopCard.displayName = 'HiddenShopCard';
export default HiddenShopCard;

//# sourceMappingURL=HiddenShopCard.js.map